import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/common/components/button';
import { Phototron } from '@/common/components/phototron';
import { redirect } from '@/common/utils';
import { getLoginPageUrl } from '@/core/services/authentication';
import { style } from './styles';

type Props = {};

export const LoginPage: FC<Props> = () => {
  const [t] = useTranslation();
  const handleRedirect = useCallback(() => redirect(getLoginPageUrl()), []);

  return (
    <div css={style}>
      <Phototron />

      <h2 className='title'>{t('page.login.title')}</h2>
      <p className='description'>{t('page.login.description')}</p>

      <Button onClick={handleRedirect} className='button'>
        {t('button.login')}
      </Button>
    </div>
  );
};
